import { ElementTypes } from '../element-types';

export class EmailLink {
  private static readonly prefix: string = 'email-link';
  static readonly Link: string = `${EmailLink.prefix}-${ElementTypes.Link}-email`;
}
